import React from "react";
import TimeAgo from "timeago-react";
import * as timeago from "timeago.js";

const localeFunc = (number: number, index: number): [string, string] => {
  return [
    ["just now", "right now"],
    ["%ss", "in %ss"],
    ["1m", "in 1m"],
    ["%sm", "in %sm"],
    ["1h", "in 1h"],
    ["%sh", "in %sh"],
    ["1d", "in 1d"],
    ["%sd", "in %sd"],
    ["1w", "in 1w"],
    ["%sw", "in %sw"],
    ["1mo", "in 1mo"],
    ["%smo", "in %smo"],
    ["1y", "in 1y"],
    ["%sy", "in %sy"],
  ][index] as [string, string];
};
timeago.register("short", localeFunc);

interface TimeAgoViewProps {
  datetime: string | number | Date;
  className?: string;
  locale?: string;
}

export function TimeAgoView(props: TimeAgoViewProps) {
  return (
    <TimeAgo
      datetime={props.datetime}
      locale={props.locale || "short"}
      className={props.className}
    />
  );
}
